
    // Configure New Relic based on import.meta.env
    const env = import.meta.env.VITE_APP_ENV;

    console.log('environment: ', env)

    if (env === 'release-dev') {
      window.NREUM.info = { applicationID: '877795661', licenseKey: '446113f3d5' };
    } else if (env === 'release-qa') {
      window.NREUM.info = { applicationID: '877796444', licenseKey: '446113f3d5' };
    } else if (env === 'release-prod') {
      window.NREUM.info = { applicationID: '877797582', licenseKey: '446113f3d5' };
    }
  